import { useEffect, useState } from 'react';

export type ActivityVisibility = 'show_all' | 'results_only';

const KEY = 'agentica_chat_settings_v2';

interface SettingsState {
  activityVisibility: ActivityVisibility;
  showSubagentCards: boolean;
}

const DEFAULT_SETTINGS: SettingsState = {
  activityVisibility: 'results_only',
  showSubagentCards: false,
};

export function useSettings() {
  const [settings, setSettings] = useState<SettingsState>(() => {
    try {
      const raw = localStorage.getItem(KEY);
      if (!raw) {
        return DEFAULT_SETTINGS;
      }
      return { ...DEFAULT_SETTINGS, ...JSON.parse(raw) } as SettingsState;
    } catch {
      return DEFAULT_SETTINGS;
    }
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(settings));
  }, [settings]);

  return {
    settings,
    setActivityVisibility: (activityVisibility: ActivityVisibility) =>
      setSettings((prev) => ({ ...prev, activityVisibility })),
    setShowSubagentCards: (showSubagentCards: boolean) =>
      setSettings((prev) => ({ ...prev, showSubagentCards })),
  };
}
